export const fiveZeroZeroErrorMessage = 'エラーが発生しました、管理者までお問い合わせください。';
